var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found-page"},[_c('div',{staticClass:"row pb-5",staticStyle:{"margin-top":"110px"}},[_c('div',{staticClass:"col-12 col-lg-10 mx-auto"},[_c('div',{staticClass:"bg-white shadow-sm"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-10 mx-auto my-5"},[_c('h1',[_vm._v("Página não encontrada :(")])])])])])])])
}]

export { render, staticRenderFns }